import React, { Component } from 'react';
import Badge from 'material-ui/Badge';
import IconButton from 'material-ui/IconButton';
import Popover from 'material-ui/Popover';
import NotificationsIcon from 'material-ui/svg-icons/social/notifications';
import ConfirmDialog from 'src/components/misc/confirm-dialog';
import { ButtonColors } from 'src/utils/constants';
import { getLocalizedValue } from 'src/utils/helpers';
import i18n from 'src/i18n';
import moment from 'moment';
import OperatorNotificationsModal, {
    NOTIFICATION_MENU_TYPES,
} from 'src/components/nav/components/operator-notifications-modal';
import { withTranslation } from 'react-i18next';
import { OPERATOR_NOTIFICATIONS_TYPE } from 'src/common';
import OperatorNotificationsPopupModal from 'src/components/nav/components/operator-notifications-popup-modal';

const OPEN_DELAY = 50;
const CLOSE_DELAY = 300;
const MAX_PREVIEW_ITEMS = 3;

class OperatorNotificationsBadge extends Component {
    state = { open: false };
    wrapperEl = null;
    timer = null;
    suppressed = false;

    componentWillUnmount() {
        this.clearTimer();
    }

    setWrapperRef = el => {
        this.wrapperEl = el;
    };

    clearTimer = () => {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
    };

    schedule = (open, delay) => {
        this.clearTimer();
        this.timer = setTimeout(() => {
            this.timer = null;
            if (this.state.open !== open) {
                this.setState({ open });
            }
        }, delay);
    };

    handleMouseEnter = () => {
        if (this.suppressed) return;
        if (this.state.open) {
            this.clearTimer();
        } else {
            this.schedule(true, OPEN_DELAY);
        }
    };

    renderNotificationRow(notification) {
        const { title, createdAt } = notification;

        return (
            <div
                className="bf-notification-preview-wrapper"
                onClick={e => {
                    e.stopPropagation();

                    this.handleOpenModal(NOTIFICATION_MENU_TYPES.NOTIFICATION);
                }}>
                <div className="col-md-10 bf-notification-preview-text">
                    <span>{this.strip(getLocalizedValue(title, i18n.language))}</span>
                    <span
                        style={{
                            marginTop: 2,
                            fontSize: 12,
                            color: '#9aa3af',
                        }}>
                        {moment(createdAt).format('DD.MM.YYYY')}
                    </span>
                </div>
                <div className="col-md-2 bf-notification-preview-icon">
                    <button type="button" className="btn btn-xs transparent">
                        <span className="glyphicon glyphicon-info-sign text-info" />
                    </button>
                </div>
            </div>
        );
    }

    strip(html) {
        let doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || '';
    }

    handleMouseLeave = () => {
        this.suppressed = false;
        if (this.state.open) {
            this.schedule(false, CLOSE_DELAY);
        } else {
            this.clearTimer();
        }
    };

    handleOpenModal = type => {
        const { openModal, t } = this.props;
        this.suppressed = true;
        this.clearTimer();
        this.setState({ open: false });

        openModal({
            component: ConfirmDialog,
            componentProps: {
                bodyText: (
                    <OperatorNotificationsModal
                        t={this.props.t}
                        notifications={this.props.newOperatorNotificationsSinceLastLogin.items}
                        openMenu={type}
                    />
                ),
                proceedText: t('common_phrases.ok'),
                proceedButtonColor: ButtonColors.NOTIFY,
                isNotification: true,
            },
            title: t('news'),
            noButtons: true,
        });
    };

    handleRequestClose = () => {
        this.clearTimer();
        this.setState({ open: false });
    };
    setIconRef = el => {
        this.iconEl = el;
    };

    renderNewTasks() {
        const { newTasksSinceLastLogin, t } = this.props;
        const taskCount = (newTasksSinceLastLogin && newTasksSinceLastLogin.count) || 0;

        const newTasksTranslation =
            taskCount === 1
                ? t('operator_notifications.modal.new_task', { count: taskCount })
                : t('operator_notifications.modal.new_tasks', { count: taskCount });
        return (
            <div
                className="bf-notification-preview-wrapper"
                onClick={e => {
                    e.stopPropagation();

                    this.handleOpenModal(NOTIFICATION_MENU_TYPES.TASK);
                }}>
                <div className="col-md-10 bf-notification-preview-text bf-notification-highlight-tasks">
                    <span>{newTasksTranslation}</span>
                </div>
                <div className="col-md-2 bf-notification-preview-icon bf-notification-highlight-tasks">
                    <button type="button" className="btn btn-xs transparent">
                        <span className="glyphicon glyphicon-info-sign" />
                    </button>
                </div>
            </div>
        );
    }

    componentDidMount() {
        const { newOperatorNotificationsSinceLastLogin } = this.props;
        const hasPopupNotifications = newOperatorNotificationsSinceLastLogin.items.filter(
            item => item.type === OPERATOR_NOTIFICATIONS_TYPE.POPUP,
        );
        if (hasPopupNotifications.length > 0) this.showPopupNotifications(hasPopupNotifications);
    }

    showPopupNotifications(notifications) {
        const { openModal, t } = this.props;

        openModal({
            component: ConfirmDialog,
            componentProps: {
                bodyText: (
                    <OperatorNotificationsPopupModal
                        t={t}
                        notifications={notifications}
                        openMenu={notifications[0].type}
                    />
                ),
                proceedText: t('common_phrases.read'),
                proceedButtonColor: ButtonColors.NOTIFY,
                isNotification: true,
            },
            title: t('news_since_last_login'),
            noButtons: true,
        });
    }

    render() {
        const { newTasksSinceLastLogin, newOperatorNotificationsSinceLastLogin, t } = this.props;
        const taskCount = (newTasksSinceLastLogin && newTasksSinceLastLogin.count) || 0;
        const notifications = newOperatorNotificationsSinceLastLogin.items;
        const totalCount = taskCount + notifications.length;
        const hiddenCount = Math.max(0, notifications.length - MAX_PREVIEW_ITEMS);

        return (
            <div
                className="notification-nav-wrapper"
                style={{ display: 'inline-block', position: 'relative' }}
                onMouseEnter={this.handleMouseEnter}
                onMouseLeave={this.handleMouseLeave}
                ref={this.setWrapperRef}>
                <Badge
                    className="nav-link notification-badge"
                    badgeContent={totalCount}
                    primary={taskCount > 0}
                    secondary={taskCount === 0}
                    style={{ padding: 0 }}
                    badgeStyle={{ top: 8, right: 26 }}>
                    <IconButton style={{ paddingRight: '60px' }} onClick={() => this.handleOpenModal(null)}>
                        <span ref={this.setIconRef} style={{ display: 'inline-block', lineHeight: 0 }}>
                            <NotificationsIcon />
                        </span>
                    </IconButton>
                </Badge>

                <Popover
                    open={this.state.open}
                    anchorEl={this.iconEl}
                    anchorOrigin={{ horizontal: 'middle', vertical: 'bottom' }}
                    targetOrigin={{ horizontal: 'middle', vertical: 'top' }}
                    onRequestClose={this.handleRequestClose}
                    useLayerForClickAway={false}
                    animated={false}
                    canAutoPosition
                    style={{
                        background: 'transparent',
                        boxShadow: 'none',
                        overflow: 'visible',
                    }}>
                    <div
                        style={{ position: 'relative', paddingTop: 12 }}
                        onMouseEnter={this.handleMouseEnter}
                        onMouseLeave={this.handleMouseLeave}>
                        <div
                            style={{
                                position: 'absolute',
                                top: 6,
                                left: '50%',
                                marginLeft: -6,
                                width: 12,
                                height: 12,
                                background: '#fff',
                                transform: 'rotate(45deg)',
                                borderRadius: 2,
                                boxShadow: '-1px -1px 2px rgba(0,0,0,0.06)',
                            }}
                        />
                        <div
                            style={{
                                position: 'relative',
                                width: 300,
                                background: '#fff',
                                borderRadius: 12,
                                boxShadow: '0 10px 30px rgba(0,0,0,0.14), 0 0 0 1px rgba(0,0,0,0.04)',
                                padding: '8px 0',
                                overflow: 'hidden',
                            }}>
                            {totalCount === 0 ? (
                                <p
                                    style={{
                                        margin: 0,
                                        padding: '16px 20px',
                                        color: '#9aa3af',
                                        fontSize: 14,
                                    }}>
                                    {t('operator_notifications.modal.no_notifications')}
                                </p>
                            ) : (
                                <div>
                                    {taskCount > 0 && this.renderNewTasks()}
                                    {notifications
                                        .slice(0, MAX_PREVIEW_ITEMS)
                                        .map((item, i) => this.renderNotificationRow(item))}
                                    {hiddenCount > 0 && (
                                        <div
                                            style={{
                                                position: 'absolute',
                                                left: 0,
                                                right: 0,
                                                bottom: 0,
                                                height: 56,
                                                pointerEvents: 'none',
                                                background: 'linear-gradient(to bottom, rgba(255,255,255,0), #fff)',
                                            }}
                                        />
                                    )}
                                </div>
                            )}

                            {totalCount > 0 && (
                                <div
                                    style={{
                                        marginTop: 4,
                                        padding: '10px 20px 6px',
                                        borderTop: '1px solid #f0f0f0',
                                        fontSize: 13,
                                        color: '#007bff',
                                        textAlign: 'center',
                                        cursor: 'pointer',
                                    }}
                                    onClick={() => this.handleOpenModal(null)}>
                                    {hiddenCount > 0 && `+${hiddenCount} ${t('operator_notifications.modal.more')} · `}
                                    {t('operator_notifications.modal.view_details')}
                                </div>
                            )}
                        </div>
                    </div>
                </Popover>
            </div>
        );
    }
}

export default withTranslation()(OperatorNotificationsBadge);
